// extracted by mini-css-extract-plugin
module.exports = {"workDays":"WorkDays_workDays__1UiRb"};